import React from 'react';
import Layout from '../components/Layout';
import InquiryForm from '../components/InquiryForm';
import { useLocation } from 'react-router-dom';
import OfficeMap from "../components/OfficeMap";

var mainOffice = {
  name: 'Main Office — Dakar City',
  address: 'N 37, Rue, Abdou Karim, Bourgi, Dakar, SENEGAL',
  phones: ['(+221) 78 593 29 13', '(+221) 77 727 85 96'],
  email: 'dakar@bluejay-travels.com',
  icon: '🏢'
};

var otherOffices = [
  {
    name: 'Dakar Airport Office',
    address: `Aéroport Blaise Diagne, Départ 3 (à l'intérieur), Dakar, SÉNÉGAL`,
    phones: ['(+221) 77 727 85 96', '(+221) 78 736 48 30'],
    email: 'airportdkr@bluejay-travels.com',
    icon: '✈️'
  },
  {
    name: 'Conakry, Guinea',
    address: '8eme Avenue Immeuble Transco, Almamya en Face de Lonagui, Conakry, Guinea',
    phones: ['(+224) 613 333 724', '(+224) 613 269 880'],
    email: 'salescky@bluejay-travels.com',
    icon: '🌍'
  },
    {
    name: 'Abidjan',
    address: 'Marcory Zone 4, Rue du Alizes, 10 BP 3473',
    phones: ['(+225) 07 198 87 362'],
    email: 'salesabj@shardatravel.com',
    icon: '🏙️'
  },
  {
    name: 'Jaipur, India',
    address: 'B-112 BC-7, Central Spine Yojana, near Akshay Patra Choraha, Jaipur 302023',
    phones: ['+91 9587532127'],
    email: 'salesjai@bluejay-travels.com',
    icon: '🇮🇳'
  }
];

var upcomingOffices = [
  { name: 'Libreville, Gabon', icon: '🇬🇦' },
  {name:'Dubai, UAE', icon:'🇦🇪'},
  {name:'Douala, Cameroon', icon:'🇨🇲'}
];

var linkStyleMain = {
  fontSize: '0.85rem',
  fontWeight: 600,
  color: 'var(--bj-sand)',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  marginBottom: 4
};

var linkStyleOther = {
  fontSize: '0.85rem',
  fontWeight: 600,
  color: 'var(--bj-clay)',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  marginBottom: 4
};

function cleanPhone(p) {
  var out = '';
  for (var i = 0; i < p.length; i++) {
    var c = p[i];
    if (c >= '0' && c <= '9') out += c;
    if (c === '+' && i === 0) out += c;
  }
  return 'tel:+' + out;
}

function OfficePhones(props) {
  var style = props.isMain ? linkStyleMain : linkStyleOther;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {props.phones.map(function(p) {
        return (
          <a key={p} href={cleanPhone(p)} style={style}>
            📞 {p}
          </a>
        );
      })}
      <a href={'mailto:' + props.email} style={style}>
        ✉️ {props.email}
      </a>
    </div>
  );
}

function OfficeCard(props) {
  var office = props.office;
  var isMain = props.isMain ? true : false;
  var [hovered, setHovered] = React.useState(false);

  var wrapStyle = {
    background: isMain ? 'linear-gradient(135deg, var(--bj-espresso), #1e3f6b)' : '#fff',
    color: isMain ? '#fff' : 'var(--bj-espresso)',
    borderRadius: 16,
    padding: isMain ? '32px 28px' : '24px 22px',
    boxShadow: hovered ? '0 20px 48px rgba(17,45,78,0.18)' : '0 6px 24px rgba(17,45,78,0.08)',
    transform: hovered ? 'translateY(-6px)' : 'translateY(0)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    borderLeft: isMain ? 'none' : '4px solid var(--bj-clay)'
  };

  var bubbleStyle = {
    width: 48,
    height: 48,
    borderRadius: 12,
    flexShrink: 0,
    background: isMain ? 'rgba(255,255,255,0.15)' : 'var(--bj-sand)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.4rem'
  };

  var titleStyle = {
    margin: '0 0 8px',
    fontSize: isMain ? '1.2rem' : '1rem',
    color: isMain ? '#fff' : 'var(--bj-espresso)'
  };

  var addrStyle = {
    margin: '0 0 12px',
    fontSize: '0.85rem',
    opacity: isMain ? 0.8 : 0.7,
    lineHeight: 1.55
  };

  return (
    <div
      style={wrapStyle}
      onMouseEnter={function() { setHovered(true); }}
      onMouseLeave={function() { setHovered(false); }}
    >
      {isMain && (
        <div style={{
          position: 'absolute', top: -40, right: -40,
          width: 160, height: 160, borderRadius: '50%',
          background: 'rgba(63,114,175,0.25)',
          pointerEvents: 'none'
        }} />
      )}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, position: 'relative' }}>
        <div style={bubbleStyle}>{office.icon}</div>
        <div style={{ flex: 1 }}>
          {isMain && (
            <span style={{
              fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em',
              textTransform: 'uppercase', opacity: 0.7, display: 'block', marginBottom: 4
            }}>
              Main Office
            </span>
          )}
          <h3 style={titleStyle}>{office.name}</h3>
          <p style={addrStyle}>📍 {office.address}</p>
          <OfficePhones phones={office.phones} email={office.email} isMain={isMain} />
        </div>
      </div>
    </div>
  );
}

function UpcomingCard(props) {
  return (
    <div style={{
      borderRadius: 14,
      padding: '20px 22px',
      background: 'var(--bj-cream-soft)',
      border: '2px dashed var(--bj-sand)',
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 10,
        background: 'var(--bj-sand)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '1.3rem', flexShrink: 0
      }}>
        {props.office.icon}
      </div>
      <div>
        <p style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem' }}>{props.office.name}</p>
        <span style={{
          fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.1em',
          textTransform: 'uppercase', color: 'var(--bj-clay)', opacity: 0.8
        }}>
          Coming Soon
        </span>
      </div>
    </div>
  );
}

export default function Contact() {
  var location = useLocation();
  var params = new URLSearchParams(location.search);
  var preselectedType = params.get('type') || 'general';
  return (
    <Layout>
      <section className="section">
        <div className="container">
          <span className="eyebrow">Get in touch</span>
          <h1>Contact Us</h1>
          <div className="two-col" style={{ marginTop: 24 }}>
            <div>
              <div className="card" style={{ padding: 24, marginBottom: 20 }}>
                <h3>Main Office</h3>
                <p>N 37, Rue, Abdou Karim, Bourgi,<br />Dakar, SENEGAL</p>
                <p>📞 <a href="tel:+221785932913">(+221) 78 593 29 13</a></p>
                <p>📞 <a href="tel:+221777278596">(+221) 77 727 85 96</a></p>
                <p>✉️ <a href="mailto:dakar@bluejay-travels.com">dakar@bluejay-travels.com</a></p>
              </div>
              <div
  style={{
    borderRadius: 20,
    overflow: "hidden",
    boxShadow: "0 12px 35px rgba(17,45,78,.12)",
    marginTop: 20
  }}
>
  <OfficeMap />
</div>
            </div>
            <InquiryForm key={preselectedType} defaultType={preselectedType} />
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--bj-cream-soft)', paddingTop: 56 }}>
        <div className="container">
          <span className="eyebrow">Our presence</span>
          <h2 style={{ marginBottom: 8 }}>Office Locations</h2>
          <p style={{ opacity: 0.7, maxWidth: 520, marginBottom: 40 }}>
            Bluejay Travels operates across West Africa and South Asia — with more locations on the way.
          </p>

          <div style={{ marginBottom: 24 }}>
            <OfficeCard office={mainOffice} isMain={true} />
          </div>

          <h3 style={{ margin: '36px 0 16px', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.5 }}>
            Other Offices
          </h3>
          <div className="grid-2" style={{ marginBottom: 40 }}>
            {otherOffices.map(function(o) {
              return <OfficeCard key={o.name} office={o} />;
            })}
          </div>

          <h3 style={{ margin: '0 0 16px', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.5 }}>
            Upcoming Offices
          </h3>
          <div className="grid-2">
            {upcomingOffices.map(function(o) {
              return <UpcomingCard key={o.name} office={o} />;
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}